export const IdTypes = [
  { label: 'South African ID', value: 'id' },
  { label: 'South African passport', value: 'sapp' },
  { label: 'Non South African passport', value: 'pp' }
];
